import createPageConstants from '../shared/util/createPageConstants';
const pluginId = 'template';
export const TemplateItemConstants = createPageConstants(pluginId, 'TemplateItem', {
  defaultDefault: 'templateItemsListPage',
  editor: 'templateItemEditorPage',
});
